// extracted by mini-css-extract-plugin
module.exports = {"LoaderHolder":"scss_LoaderHolder__4FN0p","Loader":"scss_Loader__1suU3","load3":"scss_load3__3ZqZF"};